module.exports = __webpack_public_path__ + "static/img/5.0a22ff5f.jpg";